<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script setup>

const test = process.env.VUE_APP_API_BASE_URL;
console.log('API URL:', test);
const ua = navigator.userAgent;
console.log('userAgent:', ua);
</script>


<style>
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>